import { BiLingualValue, EnvironmentValue } from 'types/common'
import { Language } from 'types/language'
import { IS_STAGING, PORTAL_URL as ENV_PORTAL_URL } from 'constants/envs'
import dayjs from 'dayjs'

export const FullLanguages = {
  [Language.DUTCH]: 'Nederlands',
  [Language.FRENCH]: 'Français'
}

export const PHONE_NOT_REACHABLE = false

export const PLENTY_URL = `${IS_STAGING ? 'https://staging.' : 'https://'}plenty.be` as const

export const PORTAL_URL = ENV_PORTAL_URL || (`${IS_STAGING ? 'https://staging.' : 'https://'}my.boltenergie.be` as const)

export enum SessionStorageKeys {
  MARKETING = 'MarketingStore',
  FROM = 'fromPage',
  PRODUCT = 'chosenProduct'
}

export const socials = {
  email: 'mailto:info@boltenergie.be',
  facebook: 'https://www.facebook.com/boltenergie/',
  instagram: 'https://www.instagram.com/boltenergie/'
}

export const PARTNER_IDS = {
  BOLT_ENERGIE_SUPERUSER: {
    PRODUCTION: '0010900001mIpTAAA0',
    STAGING: '0011q00001CH6FEAA1'
  }
} as const satisfies Record<string, EnvironmentValue<string>>

export const BOLT_ENERGIE_CARE_PARTNER_ID = '0010900001mIpTBAA0'

export const BOLT_EMAIL: BiLingualValue<string> = {
  [Language.DUTCH]: 'hallo@boltenergie.be',
  [Language.FRENCH]: 'bonjour@boltenergie.be'
}

export const BOLT_PHONE = '02 899 33 00'

export const TAKEOVER_DOCUMENT_URL: BiLingualValue<string> = {
  [Language.DUTCH]: 'https://cdn.prod.backend.boltenergie.be/pdf/bolt/energieovernamedocument.pdf',
  [Language.FRENCH]: 'https://cdn.prod.backend.boltenergie.be/pdf/bolt/document-de-reprise-des-energies.pdf'
}

export const PLENTY_INFO_NOTE: BiLingualValue<string> = {
  [Language.DUTCH]: 'https://cdn.prod.backend.boltenergie.be/pdf/plenty/informatienota.pdf',
  [Language.FRENCH]: 'https://cdn.prod.backend.boltenergie.be/pdf/plenty/note-d-information.pdf'
}

export const DEFAULT_FILE_SIZE_LIMIT = 3 * 1024 * 1024 // 3mb

export const SCHEDULED_DOWNTIME = [
  {
    start: dayjs('2026-01-17').startOf('day'),
    end: dayjs('2026-01-17').endOf('day')
  }
]
